'use client';

import { pickBlockField } from '../../lib/localized';
import { resolveReservationChannelIcon } from '../../icons/ctaLucideMap';
import type { BlockRenderProps } from '../../types';
import { ReservationChannelShell } from './ReservationChannelShell';
import { resolveExternalHref } from './reservationChannelHref';

/** External table booker — single solid CTA. */
export function ReservationThirdPartyBook(props: BlockRenderProps) {
  const bookingUrl = pickBlockField(props.block.content, 'bookingUrl', props.locale);
  const ctaIcon = pickBlockField(props.block.content, 'ctaIcon', props.locale);
  const ctaLabel = pickBlockField(props.block.content, 'ctaLabel', props.locale);
  return (
    <ReservationChannelShell
      {...props}
      channel="third-party"
      nextChromeKey="reservationNextThirdParty"
      actions={[
        {
          voice: 'third-party',
          href: resolveExternalHref(bookingUrl),
          label: ctaLabel,
          labelFieldKey: 'ctaLabel',
          iconFieldKey: 'ctaIcon',
          icon: resolveReservationChannelIcon('third-party', ctaIcon),
          openInNewTab: true,
        },
      ]}
    />
  );
}
